import { GlobalButton, FormSubmitButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

interface InviteUserFormActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  isLoading: boolean;
  disabled?: boolean;
}

const InviteUserFormActions = ({
  onCancel,
  onSubmit,
  isLoading,
  disabled = false,
}: InviteUserFormActionsProps) => (
  <div className='flex flex-wrap justify-end gap-4 rounded-lg border border-gray-200 bg-white p-6 shadow-sm'>
    <GlobalButton
      variant={GlobalButtonVariant.secondaryButton}
      action={onCancel}
    >
      Cancelar
    </GlobalButton>
    <FormSubmitButton
      label='Invitar usuario'
      action={onSubmit}
      isLoading={isLoading}
      disabled={disabled}
      icon=' '
    />
  </div>
);

export default InviteUserFormActions;
